//@flow
import ImageOrPdfUploadWithPreview from "../../../components/general/imageFileUpload/imageOrPdfUploadWithPreview";
import useFileFromApiForPreview from "../../../hooks/useFileFromApiForPreview";

const CatalogLogo = (props) => {
	const { exhibitorId, exhibitionId, disabled } = props
	
	const {
		file,
		loading,
		loadingDelete,
		deleteFile,
		uploadFile
	} = useFileFromApiForPreview({
		fetchFileUrl: `exhibitor/get-catalogue-logo/${exhibitionId}?ExhibitorId=${exhibitorId}`,
		uploadFileUrl: `exhibitor/upload-catalogue-logo/${exhibitionId}`,
		uploadFileParams: {
			ExhibitorId: exhibitorId
		},
		deleteFileUrl: `exhibitor/delete-catalogue-logo/${exhibitionId}`,
		deleteFileParams: {
			ExhibitorId: exhibitorId
		}
	})
	
	return (
		<ImageOrPdfUploadWithPreview
			loading={loading}
			loadingDelete={loadingDelete}
			deleteFile={deleteFile}
			uploadFile={uploadFile}
			file={file}
			disabled={disabled}
		/>
	)
}

export default CatalogLogo;
